import staticUrl from "../../app/utils/staticPath";

const loader = require('loader');
const flickity = require('flickity');

(function($) {

  $.fn.modal = function(options) {
    // Modal components
    const $modal = $('<div class="modal"></div>');
    const $modalInner = $('<div class="panel modal-inner"></div>');
    const $modalTitle = $('<div class="panel-header"><h2 class="panel-title"></h2></div>');
    const $modalBody = $('<div class="panel-body"></div>');
    const $modalColors = $('<ul class="color-grid faux-list"></ul>');
    const $buttonContainer = $('<div class="panel-footer inline-btns clearfix"></div>');
    const $cancelButton = $('<a href="#" class="btn modal-btn border-dark btn-cancel pull-left"></a>');
    const $confirmButton = $('<a href="#" class="btn modal-btn btn-confirm"></a>');
    const $onboarding = $('<div class="onboarding flickity-carousel"><ul class="faux-list flickity-carousel-outer"></ul></div>');


    // Default options.
    const settings = $.extend({
      title: null,
      content: null,
      cancelText: 'Cancel',
      confirmText: 'Confirm',
      disableConfirm: false,
      complete: null,
      completeCallbackParams: null,
      cancel: null,
      delayClose: false,
      tallModal: false,
      buildColours: null,
      onboarding: false,
      onboardingItem: [{
        img: null,
        title: null,
        content: null,
      }],
    }, options);


    // Build the basic modal and prepend to <body>
    const $builtModal = $modal.prepend($modalInner);
    $('body').prepend($builtModal);
    // After adding elements to the DOM, use getComputedStyle to force the browser to recalc and recognize the elements that we just added. This is so that CSS animation has a start point
    const modalElement = document.getElementsByClassName('modal')[0];
    window.getComputedStyle(modalElement).height;


    // Check if settings exists and build elements if so
    if (settings.title) {
      $modalInner.append($modalTitle);
      $modalTitle.find('.panel-title').text(settings.title);
    }

    if (settings.content) {
      $modalInner.append($modalBody);
      $modalBody.html(settings.content);
    }

    if (settings.cancelText) {
      $modalInner.append($cancelButton);
      $cancelButton.text(settings.cancelText);
    }

    if (settings.confirmText) {
      $modalInner.append($confirmButton);
      $confirmButton.text(settings.confirmText);
    }

    if (settings.disableConfirm) {
      $confirmButton.attr('disabled', true);

      const $modalInput = $modalBody.find('input');
      $modalInput.on('change', function() {
        if ($(this).val()) {
          $confirmButton.attr('disabled', false);
        }
      });
    }

    if (settings.cancelText || settings.confirmText) {
      $modal.find('.modal-btn').wrapAll($buttonContainer);
    }

    if (settings.tallModal) {
      $modal.addClass('modal-tall');
    }

    if (settings.buildColours) {
      $modalTitle.after($modalBody);
      $modalBody.append($modalColors);

      const URL = `${staticUrl()}assets/js/data/colour-names.data`;
      $.getJSON(URL, function(data) {
        $.each(data, function(colorName, colorCode) {
          $('ul.color-grid').append(`<li class="colour-item" data-color="${colorCode}" id="${colorName}" style="background-color:${colorCode}"><span>${colorName}</span></li>`);
        });
      });
    }

    if (settings.onboarding) {
      $modalInner.prepend($modalBody);
      $modalBody.prepend($onboarding);
      $cancelButton.hide();
      $confirmButton.hide();
      $('.inline-btns').prepend('<a href="#" class="btn next-btn">Next</a>');

      const $onboardingCarousel = $('.onboarding .flickity-carousel-outer');
      let flickityData;
      let flickityLength;

      const checkIfLastSlide = function() {
        if (flickityData.selectedIndex + 1 === flickityLength) {
          $('.modal .next-btn').hide();
          $confirmButton.show();
        }
      };

      const nextBtnClick = function() {
        $('.modal .next-btn').on('click', function(e) {
          e.preventDefault();
          $onboardingCarousel.flickity('next');
        });
      };

      const buildCarousel = function() {
        $onboardingCarousel.flickity({
          prevNextButtons: false,
          adaptiveHeight: true,
        });

        $onboardingCarousel.on('select.flickity', checkIfLastSlide);

        flickityData = $onboardingCarousel.data('flickity');
        flickityLength = flickityData.cells.length;
        nextBtnClick();
      };

      const createListItems = function() {
        $.each(settings.onboardingItem, function() {
          const $onboardingItem = $('<li class="onboarding-item flickity-carousel-item"></li>');
          let itemImg;
          let itemTitle;
          let itemContent;

          if (this.img) {
            itemImg = `<div class="onboarding-img ratio-16-9" style="background-image:url(${this.img});"></div>`;
          }
          if (this.title) {
            itemTitle = `<h2 class="modal-title alt-heading">${this.title}</h2>`;
          }
          if (this.content) {
            itemContent = `<div class="onboarding-content">${this.content}</div>`;
          }

          const $newItem = $onboardingItem.prepend(itemImg + itemTitle + itemContent);

          $newItem.appendTo($onboardingCarousel);
        });

        buildCarousel();
      };

      createListItems();
    }


    // Now it is built, show the modal (plus hide any loaders)
    $('window').hideLoader();
    $('window').hideBtnLoader();
    $modal.addClass('modal-open');

    // Close modal
    const closeModal = function() {
      // Remove the open class name
      $modal.removeClass('modal-open');

      // Listen for CSS transitionend event and then remove the nodes from the DOM
      $modal.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function() {
        $modal.remove();
      });
    };

    // When clicking the confirm button, run the callback
    if ($.isFunction(settings.complete)) {

      $confirmButton.on('click', function(e) {
          e.preventDefault();
          if (settings.completeCallbackParams != null) {
            settings.complete.call(this, settings.completeCallbackParams);
          }else{
            settings.complete.call(this);
          }
        if (!settings.delayClose) {
          closeModal();
        }
      });
    }

    // Cancel button functionality
    $cancelButton.on('click', function(e) {
      e.preventDefault();

      if ($.isFunction(settings.cancel)) {
        settings.cancel.call(this);
      }

      closeModal();
    });

    return this;
  };


  $.fn.closeModal = function() {
    const $modal = $('.modal');

    // Remove the open class name
    $modal.removeClass('modal-open');

    // Listen for CSS transitionend event and then remove the nodes from the DOM
    $modal.on('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function() {
      $modal.remove();
    });

    return this;
  };
}(jQuery));



// WEBPACK FOOTER //
// ./library/js/plugins/modal.js